import { type ReactNode } from 'react';
import { useAuth } from 'auth-sso-kit/client/index.js';
import { useTheme } from '../../context/ThemeContext';
import type { Page } from '../../App';

// Topbar + sidebar + cadre de contenu (classes design-kit).
const TITRES: Record<Page, string> = {
  tableau: 'Tableau de bord',
  participants: 'Participant·e·s',
  factures: 'Factures',
  admin: 'Administration',
};

export function AppShell({ page, onNavigate, eveilDisponible, children }: {
  page: Page; onNavigate: (p: Page) => void; eveilDisponible: boolean; children: ReactNode;
}) {
  const { user, logout, isAdmin } = useAuth();
  const { theme, toggleTheme, logoPosition, toggleLogoPosition } = useTheme();

  const navItem = (p: Page, label: string) => (
    <a href={`#${p}`} className={`nav-link ${page === p ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); onNavigate(p); }}>{label}</a>
  );

  return (
    <>
      <header className="topbar">
        <div className="topbar-left">
          <div className="brand">
            <img className="brand-logo" src="/logo-eveil.svg" alt="Eveil" />
            Encaissements SISP<span className="brand-sep" />
            <span className="brand-page">{TITRES[page]}</span>
          </div>
        </div>
        <div className="topbar-right">
          {!eveilDisponible && <span className="badge badge-err" title="Les séances et les personnes viennent de la base Éveil ; sans elle, l'app ne peut rien afficher.">Base Éveil injoignable</span>}
          <button className="theme-btn" onClick={toggleTheme} title="Basculer le thème">{theme === 'light' ? '☾' : '☀'}</button>
          <button className="theme-btn" onClick={toggleLogoPosition} title={logoPosition === 'bottom' ? 'Logo en bas — cliquer pour le placer en haut' : 'Logo en haut — cliquer pour le placer en bas'}>
            {logoPosition === 'bottom' ? '⤒' : '⤓'}
          </button>
          <div className="user-tag">
            <div className="user-initial">{user?.initials}</div>
            <span>{user?.name}</span>
          </div>
          {isAdmin && <span className="badge badge-accent badge-clickable" onClick={() => onNavigate('admin')} title="Administration">admin</span>}
          <button className="btn btn-sm" onClick={logout}>Déconnexion</button>
        </div>
      </header>

      <div className="shell">
        <aside className="sidebar">
          <div className="sidebar-block">
            {navItem('tableau', 'Tableau de bord')}
            {navItem('participants', 'Participant·e·s')}
            {navItem('factures', 'Factures')}
          </div>
          {isAdmin && (
            <>
              <div className="sidebar-rule" />
              <div className="sidebar-block">
                <div className="sidebar-label">Système</div>
                {navItem('admin', 'Administration')}
              </div>
            </>
          )}
          <div className="sidebar-footer">
            <img className="sidebar-logo" src="/logo-eveil.svg" alt="Eveil" />
          </div>
        </aside>
        <main className="content">{children}</main>
      </div>
    </>
  );
}
